import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ACCENT = "#4FA3D9";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the Google OAuth redirect landing at /auth/google?code=...&state=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refresh, claimPending } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const savedState = sessionStorage.getItem("adaptience_oauth_state");
      sessionStorage.removeItem("adaptience_oauth_state");
      if (params.get("error") || !code) {
        navigate("/signin", { replace: true });
        return;
      }
      if (!state || state !== savedState) {
        setError("Sign-in could not be verified. Please try again.");
        setTimeout(() => navigate("/signin", { replace: true }), 1600);
        return;
      }
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const r = await fetch(`${API}/auth/google`, {
          method: "POST", credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, redirect_uri: redirectUri, state }),
        });
        if (!r.ok) throw new Error("failed");
        await refresh();
        const claim = await claimPending();
        navigate(claim && claim.ok ? "/my-adaptience?claimed=1" : "/my-adaptience", { replace: true });
      } catch {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/signin", { replace: true }), 1600);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="flex min-h-[100dvh] w-full items-center justify-center bg-[#0a0a0a]" data-testid="google-callback">
      <div className="flex items-center gap-3 text-white/70">
        {error ? (
          <span className="text-sm text-red-300/80" data-testid="google-callback-error">{error}</span>
        ) : (
          <>
            <Loader2 size={20} className="animate-spin" style={{ color: ACCENT }} />
            <span className="text-sm">Signing you in…</span>
          </>
        )}
      </div>
    </div>
  );
}
